export function toFloat (number, offset=2) {
    if(typeof number === 'string') {
        return parseFloat(parseFloat(number).toFixed(offset))
    }
    else if (typeof number === 'number') {
        return parseFloat(number.toFixed(offset))
    }
    return number ;
}